export const DRAGGING_OVER_CAPTURE_OPTIONS = { capture: true }
